import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Box, Typography } from '@mui/material'
import { authService } from '../../utils/authService'

const Logout = (): JSX.Element => {
  const navigate = useNavigate()

  useEffect(() => {
    const logoutUser = async (): Promise<void> => {
      try {
        authService.clearAuth();
        navigate('/login-options');
      } catch (error) {
        console.error("Logout failed:", error);
      }
    };

    void logoutUser()
  }, [navigate])

  return <Box display="flex" flexDirection="column" alignItems="center">
        <img src={require('../../assets/images/3M_Active Safety_RGB_H43.png')} alt='logo' height={36} />
        <Typography variant='h3' mt={4}>Logging out...</Typography>
      </Box>
}

export default Logout
